import React, { useRef, useState, useEffect } from "react";
import { motion, useInView } from "framer-motion";

const TypingText = ({ text, speed = 0.2 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { margin: "-100px" }); // trigger every time in view
  const [animateKey, setAnimateKey] = useState(0);

  // Reset animation key whenever it comes into view
  useEffect(() => {
    if (isInView) {
      setAnimateKey(prev => prev + 1);
    }
  }, [isInView]);

  const words = text.split(" ");

  const wordVariants = {
    hidden: { opacity: 0, y: 10 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.p
      key={animateKey} // reset animation when key changes
      ref={ref}
      className="mb-4"
      initial="hidden"
      animate="visible"
      style={{ whiteSpace: "pre-wrap" }}
    >
      {words.map((word, index) => (
        <motion.span
          key={index}
          variants={wordVariants}
          transition={{ delay: index * speed, duration: 0.4 }}
          style={{ marginRight: "0.25em", display: "inline-block" }}
        >
          {word}
        </motion.span>
      ))}
    </motion.p>
  );
};

export default TypingText;
